module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfNyIgZGF0YS1uYW1lPSJMYXllciA3IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAyNyI+PGRlZnM+PHN0eWxlPi5jbHMtMXtvcGFjaXR5OjAuNzY7fS5jbHMtMntmaWxsOiMxYWRmZmY7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5iaW5fMVplaWNoZW5mbMOkY2hlIDE8L3RpdGxlPjxnIGNsYXNzPSJjbHMtMSI+PHBhdGggY2xhc3M9ImNscy0yIiBkPSJNMTQuOTQsMjdIOC44OVYxMi4xOHEwLTMuNTgtMS43OS01YTQsNCwwLDAsMC0yLjYzLS44OEg0LjFWMGguNUExMi43NiwxMi43NiwwLDAsMSw4LjIyLjVhOS4wOCw5LjA4LDAsMCwxLDQuNSwyLjgxLDEwLjQ3LDEwLjQ3LDAsMCwxLDIuMjEsN1oiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/bin-1.svg
// module id = 571
// module chunks = 1